import React from 'react'
import { TextField, Row, Column, Button, Spacing } from 'quantic'
import { useForm } from 'react-hook-form'
import NotAuthenticatedLayout from 'components/templates/Layout/NotAuthenticated'
import { Title } from './styles'

function ValidateCertificate() {
  const { register, handleSubmit, errors } = useForm()

  return (
    <NotAuthenticatedLayout>
      <form onSubmit={handleSubmit(() => null)}>
        <Row>
          <Column size={12}>
            <Title>Validar Token Certificado</Title>
          </Column>
          <Column justifyContent="space-around" size={6}>
            <img src="/assets/svg/certificate.svg" alt="ícone de certificado" />
          </Column>
          <Column justifyContent="space-around" size={6}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
            dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex
            ea commodo consequat.
          </Column>
          <Column size={12}>
            <TextField
              ref={register({ required: 'Campo obrigatório' })}
              name="authenticationCode"
              label="Código de Autenticação"
              error={errors.authenticationCode?.message}
              fullWidth
            />
          </Column>
          <Column size={12}>
            <Button primary fullWidth type="submit">
              Validar
            </Button>
          </Column>
          <Spacing size="xs" />
          <Column size={12}>
            <Button info fullWidth>
              Validar outro
            </Button>
          </Column>
        </Row>
      </form>
    </NotAuthenticatedLayout>
  )
}

export default ValidateCertificate
